// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  tokenStorageKey: 'TOKEN',
  loginUrl: '/auth/login',
  page404Url: '/404',

  apiBasePath: 'https://test.sirrent.by/backend/api/v1',
  googleMapsApiKey: 'AIzaSyB1kIckoHazifyQ28r_mDtdx_A-Oeq5LHk',

  smsTimeout: 30,
  confirmTimeout: 30,

  /* trailer registration timeout in minutes */
  registrationTimeout: 15,

  maxUploadFileSize: 1 * 1024 * 1024,
  phoneNumberMask: '(00) 000 00 00',

  dateFormat: {
    server: 'YYYY-MM-DD HH:mm:ss',
    local: 'DD.MM.YYYY HH:mm'
  },
  dateTimeFormat: 'DD.MM.YYYY HH:mm',

  map: {
    lat: 53.901215,
    lng: 27.5599138,
    zoom: 6.1
  },

  maxLengthMessage: 255,

  fragments: {
    personalData: {
      transport: 'transport'
    }
  },

  // URL for app installation instructions
  appInstallationInstructionUrlAndroid: 'http://sirrent.dev-bitrix.by/#android',
  appInstallationInstructionUrlIOS: 'http://sirrent.dev-bitrix.by/#ios',

  maintenanceMode: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
